import { Button } from "@wags/ui/button.tsx";
import {
    HomeFilledIcon,
    HourglassFilledIcon,
} from "@wags/ui/product-icons.tsx";
import {
    ADOPTION_STATUS_LABEL,
    type ChangedAdoptionStatus,
} from "@/features/listings";
import type { StatusContactAction } from "./use-dog-contact";

type StatusRowContact = Pick<
    StatusContactAction,
    "label" | "accessibleLabel" | "onClick" | "busy"
>;

const STATUS_ICON = {
    pending: HourglassFilledIcon,
    unavailable: HomeFilledIcon,
};

export function AdoptionStatusRow({
    status,
    contact,
}: {
    status: ChangedAdoptionStatus;
    contact: StatusRowContact | null;
}) {
    if (!contact) {
        return (
            <output className="flex h-11 items-center justify-center rounded-nested bg-doberman-black/5 px-3 text-label text-doberman-black/60">
                {ADOPTION_STATUS_LABEL[status]}
            </output>
        );
    }
    const Icon = STATUS_ICON[status];
    return (
        <div className="flex flex-col">
            <output className="mx-4 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-t-nested border border-b-0 border-doberman-black/10 bg-doberman-black/[0.03] px-3 pt-2 pb-4 text-body-small font-medium text-doberman-black/70">
                <Icon aria-hidden="true" className="size-3.5 shrink-0" />
                {ADOPTION_STATUS_LABEL[status]}
            </output>
            <Button
                type="button"
                emphasis="lead"
                size="touch"
                className="relative -mt-2 h-12 w-full"
                aria-label={contact.accessibleLabel}
                aria-busy={contact.busy || undefined}
                onClick={contact.onClick}
            >
                <span className="truncate">{contact.label}</span>
            </Button>
        </div>
    );
}
